import Download from '@mui/icons-material/Download'
import { Stack } from '@mui/material'
import { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'
import { useMutation, useQuery } from 'react-query'
import { clientInstallerApis } from '~/api'
import { useAppSelector } from '~/app/hooks'
import { CLIENT_INSTALLER_KEYS } from '~/constants/APIs'
import { useHandleError } from '~/hooks'
import { ALL_NS } from '~/i18n/namespaces'
import { isDarkTheme } from '~/redux/features'
import { EFButton } from '../EFButton/EFButton.component'

export function ClientInstallerPopup() {
  const { t } = useTranslation(ALL_NS)
  const isDark = useAppSelector(isDarkTheme)
  const { showAxiosErrorDialog } = useHandleError()

  const { data, isLoading, isError, error } = useQuery(
    [CLIENT_INSTALLER_KEYS.GET_INSTALLER],
    () => clientInstallerApis.getInstaller()
  )

  const mutationDownload = useMutation(
    CLIENT_INSTALLER_KEYS.DOWNLOAD,
    () => clientInstallerApis.downLoadSetup('/' + data?.setupUrl ?? ''),
    {
      onError(error, _variables, _context) {
        showAxiosErrorDialog(error)
      }
    }
  )
  return (
    <Stack>
      {isError && (error as AxiosError).status === 404 ? (
        t('Message_tk0_EntityNotFound', { 0: 'Client Installer' })
      ) : (
        <Stack
          sx={{
            background: isDark ? 'var(--dark-gray-background)' : 'var(--light-gray)',
            borderRadius: '1rem',
            padding: '2rem 0',
            textAlign: 'center'
          }}
        >
          <EFButton
            isLoading={isLoading}
            disabled={isLoading || isError}
            startIcon={<Download />}
            onClick={() => mutationDownload.mutate()}
          >
            {isError
              ? t('MessageTitle_Error')
              : t('Link_Install_tk0__tk1_', { 0: data?.name, 1: data?.version })}
          </EFButton>
        </Stack>
      )}
    </Stack>
  )
}
